export default __webpack_public_path__ + "static/media/Head_6_Ear_1_C4.343609c9.svg";